import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { SeverityLevelResponse } from '@/types/apps/severity-level-type.type';
import type { ApiResponse, PaginatedResult } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface SeverityLevelServiceInterface {}

type SeverityLevelGraphQLListResponse = ApiResponse<
    PaginatedResult<SeverityLevelResponse>
>;

export class SeverityLevelGraphQLService
    extends BaseService
    implements SeverityLevelServiceInterface
{
    public getEntityName(): string {
        return 'severityLevel';
    }

    public getFields(): Record<string, any> {
        return {
            color: true,
            createdBy: true,
            createdDate: true,
            description: true,
            id: true,
            isDeleted: true,
            name: true,
        };
    }

    public async index(
        query: string
    ): Promise<SeverityLevelGraphQLListResponse> {
        return this.fetchGqlList<SeverityLevelGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        return {};
    }
}
